import React from 'react';
import Page from "@/components/layout/Page";
import StaticContent from '@/components/common/StaticContentPage';

const AboutPage = () => {
	return (
		<Page pageTitle={'About Trivial Pursuit Infinite'}>
      <StaticContent header={`About Trivial Pursuit Infinite`}>
        <h2 className={`font-gSemi text-center self-center max-w-[250px] py-3`}>{`We're in the pursuit of better trivia — with your help!`}</h2>
        <p className='font-gReg'>
          {`What if you could play Trivial Pursuit with any topic you can dream up? Songbirds, the history of the samurai, character actors of the 1990's... Your interests pave the path!`}
        </p>
        <p className='font-gReg'>
          {`Welcome to our next-gen trivia experience, powered by AI. It's vast, it's varied, and it's custom-tailored to your curiosity.`}
        </p>
        <p className='font-gReg'>
          {`Now we need trivia whizzes like you to help make it better! After each question, you'll have the chance to give us feedback so we can improve our Trivia AI.`}
        </p>
        <p className={`text-center font-gSemi`}>
          {`Let's get started and shape the future of trivia!`}
        </p>
      </StaticContent>
		</Page>
	);
};

export default AboutPage;
